import { render, staticRenderFns } from "./OfSelection.vue?vue&type=template&id=b3631fa0&scoped=true"
import script from "./OfSelection.vue?vue&type=script&lang=js"
export * from "./OfSelection.vue?vue&type=script&lang=js"
import style0 from "./OfSelection.vue?vue&type=style&index=0&id=b3631fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3631fa0",
  null
  
)

export default component.exports